export const calculateBestOf = (totalWinsNeeded?: number) => {
  if (!totalWinsNeeded) {
    return 1;
  }
  return totalWinsNeeded * 2 - 1;
};
